export default "__VITE_ASSET__Yk61kFmr__"